import { Chain } from 'wagmi'
import { IChainData } from './types'

export const SUPPORTED_CHAINS: IChainData[] = [
  {
    name: 'Ethereum Mainnet',
    short_name: 'eth',
    chain: 'ETH',
    network: 'mainnet',
    chain_id: 1,
    network_id: 1,
    rpc_url: 'https://mainnet.infura.io/v3/%API_KEY%',
    native_currency: {
      symbol: 'ETH',
      name: 'Ether',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Ethereum Ropsten',
    short_name: 'rop',
    chain: 'ETH',
    network: 'ropsten',
    chain_id: 3,
    network_id: 3,
    rpc_url: 'https://ropsten.infura.io/v3/%API_KEY%',
    native_currency: {
      symbol: 'ETH',
      name: 'Ether',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Ethereum Rinkeby',
    short_name: 'rin',
    chain: 'ETH',
    network: 'rinkeby',
    chain_id: 4,
    network_id: 4,
    rpc_url: 'https://rinkeby.infura.io/v3/%API_KEY%',
    native_currency: {
      symbol: 'ETH',
      name: 'Ether',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Ethereum Göerli',
    short_name: 'gor',
    chain: 'ETH',
    network: 'goerli',
    chain_id: 5,
    network_id: 5,
    rpc_url: 'https://goerli.infura.io/v3/%API_KEY%',
    native_currency: {
      symbol: 'ETH',
      name: 'Ether',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'RSK Mainnet',
    short_name: 'rsk',
    chain: 'RSK',
    network: 'mainnet',
    chain_id: 30,
    network_id: 30,
    rpc_url: 'https://public-node.rsk.co',
    native_currency: {
      symbol: 'RSK',
      name: 'RSK',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Ethereum Kovan',
    short_name: 'kov',
    chain: 'ETH',
    network: 'kovan',
    chain_id: 42,
    network_id: 42,
    rpc_url: 'https://kovan.infura.io/v3/%API_KEY%',
    native_currency: {
      symbol: 'ETH',
      name: 'Ether',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Ethereum Classic Mainnet',
    short_name: 'etc',
    chain: 'ETC',
    network: 'mainnet',
    chain_id: 61,
    network_id: 1,
    rpc_url: 'https://ethereumclassic.network',
    native_currency: {
      symbol: 'ETH',
      name: 'Ether Classic',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'POA Network Sokol',
    short_name: 'poa',
    chain: 'POA',
    network: 'sokol',
    chain_id: 77,
    network_id: 77,
    rpc_url: 'https://sokol.poa.network',
    native_currency: {
      symbol: 'POA',
      name: 'POA',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'POA Network Core',
    short_name: 'skl',
    chain: 'POA',
    network: 'core',
    chain_id: 99,
    network_id: 99,
    rpc_url: 'https://core.poa.network',
    native_currency: {
      symbol: 'POA',
      name: 'POA',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'xDAI Chain',
    short_name: 'xdai',
    chain: 'POA',
    network: 'dai',
    chain_id: 100,
    network_id: 100,
    rpc_url: 'https://dai.poa.network',
    native_currency: {
      symbol: 'xDAI',
      name: 'xDAI',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Callisto Mainnet',
    short_name: 'clo',
    chain: 'callisto',
    network: 'mainnet',
    chain_id: 820,
    network_id: 1,
    rpc_url: 'https://clo-geth.0xinfra.com/',
    native_currency: {
      symbol: 'CLO',
      name: 'CLO',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
  {
    name: 'Polygon Testnet Mumbai',
    chain: 'Polygon',
    network: 'mumbai',
    rpc_url: 'https://rpc-mumbai.maticvigil.com',
    native_currency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
    short_name: 'maticmum',
    chain_id: 80001,
    network_id: 80001,
  },
  {
    name: 'Polygon Mainnet',
    chain: 'Polygon',
    network: 'mainnet',
    rpc_url: 'https://rpc-mainnet.maticvigil.com',
    native_currency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
    short_name: 'MATIC',
    chain_id: 137,
    network_id: 137,
  },
  {
    name: 'Avalanche Fuji Testnet',
    chain: 'AVAX',
    network: 'fuji',
    rpc_url: 'https://api.avax-test.network/ext/bc/C/rpc',
    native_currency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
    short_name: 'Fuji',
    chain_id: 43113,
    network_id: 1,
  },
  {
    name: 'Avalanche Mainnet',
    chain: 'AVAX',
    network: 'mainnet',
    rpc_url: 'https://api.avax.network/ext/bc/C/rpc',
    native_currency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
    short_name: 'Avalanche',
    chain_id: 43114,
    network_id: 43114,
  },
  {
    name: 'Arbitrum One',
    chain_id: 42161,
    network_id: 42161,
    network: 'mainnet',
    short_name: 'arb1',
    chain: 'ETH',
    native_currency: {
      name: 'Ether',
      symbol: 'AETH',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
    rpc_url: 'https://arbitrum-mainnet.infura.io/v3/%API_KEY%',
  },
  {
    name: 'Optimism',
    chain: 'ETH',
    rpc_url: 'https://mainnet.optimism.io/',
    network: 'mainnet',
    native_currency: {
      name: 'Ether',
      symbol: 'OETH',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
    short_name: 'oeth',
    chain_id: 10,
    network_id: 10,
  },
]

export const gnosisChiado: Chain = {
  id: 10200,
  name: 'Chiado',
  network: 'Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'GNO',
    symbol: 'CHI',
  },
  rpcUrls: {
    default: { http: ['https://rpc.chiado.gnosis.dev.gateway.fm/'] },
  },
  blockExplorers: {
    default: { name: 'SnowTrace', url: 'https://blockscout.chiadochain.net' },
  },
  testnet: true,
}

export const gnosisMainnet: Chain = {
  id: 100,
  name: 'Gnosis Chain',
  network: 'Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'GNO',
    symbol: 'xDai',
  },
  rpcUrls: {
    default: { http: ['https://rpc.gnosis.dev.gateway.fm/'] },
  },
  blockExplorers: {
    default: { name: 'SnowTrace', url: 'https://gnosisscan.io' },
  },
  testnet: false,
}
export const goerliEther: Chain = {
  id: 5,
  name: 'Göerli',
  network: 'goerli',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: {
      http: [`https://goerli.infura.io/v3/${process.env.INFURA_ID}`],
    },
  },
  blockExplorers: {
    default: { name: 'EtherScan', url: 'https://goerli.etherscan.io/' },
  },
  testnet: false,
}

export const NETWORKS: INetworks = {
  100: {
    forkVersion: '00000064',
    chainId: 100,
    name: 'Gnosis Chain',
    symbol: 'XDAI',
    chainName: 'Gnosis Chain',
    rpcUrl: 'https://rpc.chiado.gnosis.dev.gateway.fm',
    blockExplorerUrl: 'https://blockscout.com/xdai/mainnet',
    beaconExplorerUrl: 'https://beacon.gnosischain.com',
    addresses: {
      token: '0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb',
      deposit: '0x0B98057eA310F4d31F2a452B414647007d1645d9',
      dappnodeDeposit: '0x6C68322cf55f5f025F2aebd93a28761182d077c3',
    },
    depositStartBlockNumber: 22673201,
  },
  10200: {
    forkVersion: '0000006f',
    chainId: 10200,
    name: 'Chiado',
    symbol: 'CHI',
    chainName: 'Chiado Testnet',
    rpcUrl: 'https://rpc.chiadochain.net',
    blockExplorerUrl: 'https://blockscout.chiadochain.net',
    beaconExplorerUrl: 'https://beacon.chiadochain.net',
    addresses: {
      token: '0x19C653Da7c37c66208fbfbE8908A5051B57b4C70',
      deposit: '0xb97036A26259B7147018913bD58a774cf91acf25',
      dappnodeDeposit: null,
    },
    depositStartBlockNumber: 0,
  },
}
export interface INetworks {
  100: INetwork
  10200: INetwork
}
export interface INetwork {
  forkVersion: string
  chainId: number
  name: string
  symbol: string
  chainName: string
  rpcUrl: string
  blockExplorerUrl: string
  beaconExplorerUrl: string
  addresses: Addresses
  depositStartBlockNumber: number
}
export interface Addresses {
  token: string
  deposit: string
  dappnodeDeposit?: string
}
